import { onBeforeUpdate, ref, useSlots } from 'vue'

import type { ParentSlots } from './types'

export function useDynamicSlots(slotsToHandle?: string[]) {
  const dynamicSlotNames = ref<string[]>(slotsToHandle || [])
  const dynamicSlotsList = ref<Record<string, ParentSlots>>({})

  function getDynamicSlots(exp: string): ParentSlots {
    const slots = useSlots()

    if (slots) {
      const dynamicSlots = Object.keys(slots).reduce<ParentSlots>((acc, slot) => {
        if (slot.includes(exp)) {
          acc[slot] = slots[slot] as () => any
        }

        return acc
      }, {})

      return dynamicSlots
    }

    return {}
  }

  function refreshDynamicSlots(): void {
    dynamicSlotNames.value.forEach(slot => {
      dynamicSlotsList.value[slot] = getDynamicSlots(slot)
    })
  }

  onBeforeUpdate(() => {
    refreshDynamicSlots()
  })

  refreshDynamicSlots()

  return { dynamicSlotsList }
}
